import { updateWinnerAPI } from '@src/api/raffle-draw';
import { allUsersAPI } from '@src/api/users';
import { usePartnerDropdownContext } from '@src/context/PartnerDropdown';
import { useToasterContext } from '@src/context/Toaster';
import { AlertType } from '@src/lib/types/toaster';
import { useMutation, useQuery } from '@tanstack/react-query';

export const useSearchUser = (userId: string, enabled: boolean) => {
  const { state: { selectedPartnerId } } = usePartnerDropdownContext();

  return useQuery({
    queryKey: ['search-winner-user', { userId, selectedPartnerId }],
    queryFn: () => allUsersAPI({ partnerId: selectedPartnerId, search: userId, size: 1, page: 1 }),
    enabled: enabled && !!userId.trim(),
    select: (res) => res?.items?.[0] ?? null,
  });
};

export const useUpdateWinner = (onSuccess?: () => void) => {
  const { triggerOpen } = useToasterContext();

  return useMutation({
    mutationKey: ['update-winner'],
    mutationFn: ({ raffleId, place, userId }: { raffleId: number; place: number; userId: number }) =>
      updateWinnerAPI(raffleId, { place, userId }),
    onSuccess: () => {
      triggerOpen({ title: 'Update Winner', message: 'Winner updated successfully' });
      onSuccess?.();
    },
    onError: (err: any) => {
      triggerOpen({
        type: AlertType.error,
        title: 'Update Winner',
        message: typeof err === 'string' ? err : 'Failed to update winner',
      });
    },
  });
};
